/**
 * Modelo do CMP interno (cookie/RGPD consent) — apenas sites dealer.
 * Categorias: necessary (sempre on) / analytics (GA+GTM) / marketing (FB Pixel + custom scripts).
 */

export type ConsentCategory = 'necessary' | 'analytics' | 'marketing';

export interface ConsentState {
  necessary: true; // sempre activo
  analytics: boolean;
  marketing: boolean;
  version: number; // POLICY_VERSION à data da decisão
  timestamp: string; // ISO
}

/** Bump para forçar re-prompt (ex.: mudança do texto da policy). */
export const POLICY_VERSION = 1;

/** Chave no localStorage (encriptada via Storage). */
export const CONSENT_STORAGE_KEY = 'ade_consent';
